import './xDocList.css';
import { FaFacebook, FaYoutubeSquare, FaInstagram, FaEnvelopeSquare } from 'react-icons/fa';

export default function Address({ distance }) {

  return (
  
    <footer className="footer-container">
      {/* COLUMN 1: HOURS */}
      <div className="footer-col hours-col">
        <div className="glassAddress">
          <strong>
            <span className="orange">HOURS OF OPERATION</span>
          </strong>
          <p className="white-text">
            Monday thru Saturday:<br /> 5:00pm to 2:00am<br />
            Sunday: 2:00pm to 2:00am
          </p>
        </div>
      </div>

      <hr className="footer-divider" />

      {/* COLUMN 2: ADDRESS & DISTANCE */}
      <div className="footer-col address-col">
        <div className="glassAddress">
          <a href="tel:5052438476" className="orange no-underline">
            <strong>(505) 243-8476</strong>
          </a>
          
          <a 
            className="no-underline"
            target="_blank" 
            rel="noopener noreferrer" 
            href="https://www.google.com/maps/search/?api=1&query=201+Highland+Park+Cir+Albuquerque+NM+87102"
          >
            <address className="white-text">
              201 Highland Park Cir, Albuquerque, NM 87102
            </address>
            <div className="location-stats white-text">
              {/* 🟢 FIXED: Safe conversion check to guarantee numbers render instantly on screen */}
              {distance !== null && distance !== undefined && !isNaN(Number(distance)) ? (
                <>
                  <span className="white-text"><strong>{distance}</strong></span> meters to the club
                </>
              ) : (
                <span className="loading-text">Locating club...</span>
              )}
            </div>
          </a>
        </div>
      </div>

      <hr className="footer-divider" />

      {/* COLUMN 3: SOCIALS */}
      <div className="footer-col socials-col">
        <div className="footer-socials">
          <a href="https://www.facebook.com/ABQPressClub/" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaFacebook />
          </a>
          <a href="https://www.instagram.com/abqpressclub" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaInstagram />
          </a>
          <a href="https://www.youtube.com/@abqpressclub" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaYoutubeSquare />
          </a>
          <a href="mailto:abqpressclubmembership@gmail.com" className="social-link">
            <FaEnvelopeSquare />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright-text apc-text white">
          © {new Date().getFullYear()} Albuquerque Press Club
        </p>
      </div>
    </footer>
  );
}